import React, { Component } from 'react';
import { Tree, Input ,Icon,Select,Button} from 'antd';
import { proxy } from '../../helpers/util';
import _ from 'lodash'
const { TreeNode } = Tree;
const Search = Input.Search;
const Option = Select.Option;
let selectedKey2Title = null, key2Data = null, title2ResultKey = null
export default class definedLeftcontent extends React.Component {
  constructor(props) {
    super(props);
    let billNo = this.props.model.getParams().billNo
    this.state = {
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: true,
      selectedKeys: [],
      selectName: '',
      billNo: billNo,
      billNodata: [],
      entitydata: [],
      isClear:false,
      selecData:[]
    }
  }
  componentDidMount() {
    let { billNo } = this.state;
    this.getdataSource(billNo)
  }
  async getdataSource(billNo) {
    const config = {
      url: 'report/getEntityInfoByBillNo.do',
      method: 'GET',
      params: {
        billno: billNo
      }
    };
    const json = await proxy(config);
    if (json.code !== 200) return
    let billNodata = json.data
    key2Data = {};
    selectedKey2Title = {};
    title2ResultKey = {};
    this.rebuildTreeData(billNodata);
    this.setState({ billNodata })
  }
   //搜索树节点
   getParentKey = (billNodata,value,selecData) => {
    let self = this;
   billNodata.forEach(function(ele){
     if(ele.title.indexOf(value) > -1){
       if( ele.children){
         selecData.push(ele)
         self.getParentKey(ele.children,value,selecData);  
       }
       else{
        selecData.push(ele)
       }
     }
     else if(ele.children && ele.children.length > 0){
      self.getParentKey(ele.children,value,selecData);
     }
   })
  };
  //通过点击＋或者-触发
  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  }
   //搜索框搜索
  onChange = (e, treeNode) => {
    let { billNodata,isClear} = this.state
    const value = e.target.value;
    let expandedKeys = [];
    if(value !="" && billNodata && billNodata.length > 0){
      this.getParentKey(billNodata,value,expandedKeys);
    }
    isClear = value ? true: false;
    this.setState({
      expandedKeys,
      searchValue: value,
      isClear,
      autoExpandParent: true
    });
  }
    //树节点选择
  onTreeselect(selectedKeys, e) {
    if (!selectedKeys.length) {
      selectedKeys = this.state.selectedKeys
    }
    let selectionStart = this.props.selectionStart;
    let conditionDesc = '';
    if (this.props.operatorValue) {
      conditionDesc = this.props.operatorValue
      selectionStart = conditionDesc.length
    }
    const leftExp = conditionDesc.substr(0, selectionStart);
    const rightExp = conditionDesc.substr(selectionStart);
    conditionDesc = leftExp + selectedKey2Title[selectedKeys[0]] + rightExp
    selectionStart = conditionDesc.length;
    this.setState({ selectName: e.selectedNodes, selectedKeys })
    this.props.onSelect(conditionDesc, selectionStart)
  }
    //异步加载节点数据
  loadData = (treeNode) => {
    let self = this;
    self.getLoadData(treeNode);
  }
  async getLoadData(treeNode) {
    let { billNodata } = this.state
    let key = treeNode.props.eventKey;
    const expandData = key2Data[key];
    const { entityName } = expandData;
    const config = {
      url: 'report/getEntityInfoByName.do',
      method: 'GET',
      params: { entityName }
    };
    const json = await proxy(config);
    if (json.code !== 200) return
    expandData.children = json.data;
    key2Data = {};
    selectedKey2Title = {};
    title2ResultKey = {};
    billNodata = billNodata.map(t => {
      return t.mergeCode == expandData.mergeCode ? expandData : t;
    });
    this.rebuildTreeData(billNodata);
    this.setState({ billNodata })
  }
    //构建树
    rebuildTreeData(data, mergeCode, mergeName) {
      if(data && data.length > 0){
        data.forEach(item => {
          const codes = [], names = [];
          if (mergeCode)
            codes.push(mergeCode);
          codes.push(item.name);
          if (mergeName)
            names.push(mergeName);
          names.push(item.title);
          item.mergeCode = codes.join('.');
          key2Data[item.mergeCode] = item;
          item.mergeName = names.join('.');
          const mergeTitle = `[${item.mergeName}]`;
          selectedKey2Title[item.mergeCode] = mergeTitle;
          title2ResultKey[mergeTitle] = item.mergeCode;
          if (!item.children) return;
          this.rebuildTreeData(item.children, item.mergeCode, item.mergeName);
        });
      }
    }
 //清空搜索框
 emitEmpty=()=>{
  let {isClear}=this.state;
  let value  = '';
  isClear  = value?true:false;
  this.setState({
    isClear,
    searchValue:value,
    expandedKeys:[],
    autoExpandParent:false,
    selecData:[]
  })
}
  //搜索选择
  searchSelect(value, option) {
    let {searchValue,billNodata} = this.state
    let expandedKeys  = [];
    searchValue =  option.props.children
    let _index = null
    this.loopSelect(billNodata,value,expandedKeys,_index)
    this.setState({
      expandedKeys:expandedKeys,
      searchValue,
      autoExpandParent: true
    })
  }
  loopSelect(billNodata,value,expandedKeys,index){
    let self = this;
    let newindex = index;
    let NewBillNodata = billNodata;
    let selectdata = [];
    if(index != null){
      selectdata = billNodata[index]
      NewBillNodata = billNodata[index].children ?billNodata[index].children:[].push(billNodata[index]);
    }
    NewBillNodata.forEach(function(ele,index){
      if(ele.mergeCode  == value){
        if( ele.children){
          expandedKeys.push(selectdata.mergeCode)
          self.loopSelect(NewBillNodata,value,expandedKeys,index);  
        }
        if(!ele.children && !ele.isExpand){
          expandedKeys.push(ele.mergeCode)
        }
        if(!ele.children && ele.isExpand){
          expandedKeys.push(selectdata.mergeCode)
        }
      }
      else if(ele.children && ele.children.length > 0){
        self.loopSelect(NewBillNodata,value,expandedKeys,index);
      }
    })
  }
    //搜索框搜索
    onSearch(value) {
      let { billNodata,isClear} = this.state
      let expandedKeys = [];
      let selecData = [];
      if(value !="" && billNodata && billNodata.length > 0){
        this.getParentKey(billNodata,value,selecData);
      }
      if(value === ""){
        selecData = [];
        expandedKeys = [];
      }
      isClear = value ? true: false;
      this.setState({
        searchValue: value,
        isClear,
        selecData,
        expandedKeys
      });
    }
      //渲染搜索值
  getSearchOptions() {
    let {searchValue,selecData} = this.state;
    if (searchValue == '') return
    let options = [];
    if(!selecData.length) {options.push(<Option key={'nodata'} className="haveNodata" disabled>{"暂无搜索结果～"}</Option>)};
    selecData.forEach(function (ele) {
      options.push(<Option key={ele.mergeCode} className={ele.isCheck?"selected":"haveNoselect"}>{ele.title}</Option>)
    }, this);
    return options;
  }
  render() {
    const { searchValue, expandedKeys, autoExpandParent, selectName, billNodata, entitydata,isClear} = this.state;
    const loop = data => data.map((item) => {
      const { mergeCode, isExpand, children } = item;
      const index = item.title.indexOf(searchValue);
      const beforeStr = item.title.substr(0, index);
      const afterStr = item.title.substr(index + searchValue.length);
      const title = index > -1 ? (
        <span>
          {beforeStr}
          <span style={{ color: '#f50' }}>{searchValue}</span>
          {afterStr}
        </span>
      ) : <span>{item.title}</span>;
      if (isExpand) {
        return (
          <TreeNode key={mergeCode} title={title}>
            {loop((children || []))}
          </TreeNode>
        );
      }
      return <TreeNode key={mergeCode} title={title} isLeaf />;
    });
    let loopData = billNodata == false ? null:loop(billNodata)
    let clearValue = isClear?<Icon type="close-circle" onClick={()=>this.emitEmpty()} />:null;
    let options = this.getSearchOptions();
    return (
      <div className="defind_all">
        <Button icon="search" className="defind_icon"/>
          <Select placeholder={this.state.placeholder} mode="combobox" value={this.state.searchValue}
          className="defind_select"
            onSelect={(value, option) => this.searchSelect(value, option)} onSearch={(value) => this.onSearch(value)}
            defaultActiveFirstOption={false} showArrow={false} filterOption={false} onChange={this.handleChange} dropdownMatchSelectWidth={false}>
            {options}
          </Select>
        {clearValue}
        <Tree
          selectedKeys={this.state.selectedKeys}
          onSelect={(selectedKeys, e) => this.onTreeselect(selectedKeys, e)}
          onExpand={this.onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          loadData={this.loadData}
        >
          {loopData}
        </Tree>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/filter/definedLeftcontent.jsx